import { inject } from "@angular/core"
import { SysLoginService } from "./sys-login.service"
import { Router } from "@angular/router";

export const sysLoginGuard = () => {
    const tokenInvalid = ! inject(SysLoginService).tokenValid;
    if ( tokenInvalid ) {
        inject(Router).navigate(['/acesso']);
    }
    return ! tokenInvalid
}